import ProductActionTypes from "./product.types";

/** ***************** GET PRODUCT LIST START *********************** */
export const getProductListStart = (getData: any) => ({
  type: ProductActionTypes.GET_PRODUCT_LIST_START,
  payload: getData,
});

export const getProductListSuccess = (successData: any) => ({
  type: ProductActionTypes.GET_PRODUCT_LIST_SUCCESS,
  payload: successData,
});

export const getProductListFailure = (failureData: any) => ({
  type: ProductActionTypes.GET_PRODUCT_LIST_FAILURE,
  payload: failureData,
});

export const getProductListResponseResetStart = () => ({
  type: ProductActionTypes.GET_PRODUCT_LIST_RESPONSE_RESET,
});

export const getProductListResponseChanged = () => ({
  type: ProductActionTypes.GET_PRODUCT_LIST_RESPONSE_CHANGED,
});

/** ***************** GET PRODUCT LIST END *********************** */

/** ***************** ADD PRODUCT DETAILS START *********************** */
export const addProductDetailsStart = (addData: any) => ({
  type: ProductActionTypes.ADD_PRODUCT_DETAILS_START,
  payload: addData,
});

export const addProductDetailsSuccess = (successData: any) => ({
  type: ProductActionTypes.ADD_PRODUCT_DETAILS_SUCCESS,
  payload: successData,
});

export const addProductDetailsFailure = (failureData: any) => ({
  type: ProductActionTypes.ADD_PRODUCT_DETAILS_FAILURE,
  payload: failureData,
});

export const addProductDetailsResponseResetStart = () => ({
  type: ProductActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const addProductDetailsResponseChanged = () => ({
  type: ProductActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** ADD PRODUCT DETAILS END *********************** */

/** ***************** UPDATE PRODUCT DETAILS START *********************** */
export const updateProductDetailsStart = (updateData: any) => ({
  type: ProductActionTypes.UPDATE_PRODUCT_DETAILS_START,
  payload: updateData,
});

export const updateProductDetailsSuccess = (successData: any) => ({
  type: ProductActionTypes.UPDATE_PRODUCT_DETAILS_SUCCESS,
  payload: successData,
});

export const updateProductDetailsFailure = (failureData: any) => ({
  type: ProductActionTypes.UPDATE_PRODUCT_DETAILS_FAILURE,
  payload: failureData,
});

export const updateProductDetailsResponseResetStart = () => ({
  type: ProductActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const updateProductDetailsResponseChanged = () => ({
  type: ProductActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE PRODUCT DETAILS END *********************** */

/** ***************** DELETE PRODUCT DETAILS START *********************** */
export const deleteProductDetailsStart = (deleteData: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_DETAILS_START,
  payload: deleteData,
});

export const deleteProductDetailsSuccess = (successData: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_DETAILS_SUCCESS,
  payload: successData,
});

export const deleteProductDetailsFailure = (failureData: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_DETAILS_FAILURE,
  payload: failureData,
});

export const deleteProductDetailsResponseResetStart = () => ({
  type: ProductActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const deleteProductDetailsResponseChanged = () => ({
  type: ProductActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** DELETE PRODUCT DETAILS END *********************** */

/** ***************** FETCH PRODUCT DETAILS START *********************** */
export const fetchProductDetailsStart = (fetchData: any) => ({
  type: ProductActionTypes.FETCH_PRODUCT_DETAILS_START,
  payload: fetchData,
});

export const fetchProductDetailsSuccess = (successData: any) => ({
  type: ProductActionTypes.FETCH_PRODUCT_DETAILS_SUCCESS,
  payload: successData,
});

export const fetchProductDetailsFailure = (failureData: any) => ({
  type: ProductActionTypes.FETCH_PRODUCT_DETAILS_FAILURE,
  payload: failureData,
});

export const fetchProductDetailsResponseResetStart = () => ({
  type: ProductActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_RESET,
});

export const fetchProductDetailsResponseChanged = () => ({
  type: ProductActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_CHANGED,
});

/** ***************** FETCH PRODUCT DETAILS END *********************** */

/** ***************** DELETE PRODUCT QUESTION START (single question) *********************** */
export const deleteProductQuestionStart = (payload: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_QUESTION_START,
  payload,
});

export const deleteProductQuestionSuccess = (successData: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_QUESTION_SUCCESS,
  payload: successData,
});

export const deleteProductQuestionFailure = (failureData: any) => ({
  type: ProductActionTypes.DELETE_PRODUCT_QUESTION_FAILURE,
  payload: failureData,
});

export const deleteProductQuestionResponseResetStart = () => ({
  type: ProductActionTypes.DELETE_PRODUCT_QUESTION_RESPONSE_RESET,
});

export const deleteProductQuestionResponseChanged = () => ({
  type: ProductActionTypes.DELETE_PRODUCT_QUESTION_RESPONSE_CHANGED,
});
/** ***************** DELETE PRODUCT QUESTION END *********************** */
